module.exports = __webpack_public_path__ + "img/logo-header.e57e0cdb.svg";